<template>
  <div class="rs-prop-location">
    <RsIcon
      weight="far"
      icon="map-marker-alt"
    />
    <a
      v-if="link"
      :href="link"
      v-html="text"
    />
    <div
      v-else-if="pointer"
      class="d-inline"
      @mouseover="isMouseOverLocation = true"
      @mouseleave="isMouseOverLocation = false"
      @click="$emit('expandedIdx')"
    >
      <span
        class="property-link"
        v-html="text"
      />
      <RsIcon
        v-if="isMouseOverLocation"
        class="d-inline penIcon ml-1"
        icon="pencil"
      />
    </div>
    <span
      v-else
      v-html="text"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPropLocation',

  props: {
    link: String,
    text: String,
    pointer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMouseOverLocation: false as boolean,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-prop-location{
  font-size: 0.875rem;
  color: $extra-light-gray;
  .rs-icon{
    margin-right: 2px;
  }
  a{
    color: $dark-gray;
  }
}
.penIcon {
    color: $primary-color;
    font-size: 1.0rem;
  }
.property-link {
  &:hover {
    color: $primary-color;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
